import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { PaymentsErrorCodes } from '../error-codes/payments.type';
import { PaymentsSuccessCodes } from '../success-codes/payments.type';
import { defaultPaymentAlerts } from './en-GB/payments';
import { SupportedToasterLocales } from './general.utils';

export const paymentsTranslations: {
  // For new locales just add them here to the extract
  [key in SupportedToasterLocales]: typeof defaultPaymentAlerts;
} = {
  [Locale.en_GB]: defaultPaymentAlerts,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generatePaymentsAlerts = (translations: typeof defaultPaymentAlerts) => ({
  [PaymentsErrorCodes.REQUEST_ORG_MISMATCH]: {
    name: 'Your Organisation mismatch',
    type: AlertTypes.ERROR,
    title: translations.REQUEST_ORG_MISMATCH_TITLE,
    description: translations.REQUEST_ORG_MISMATCH_DESCRIPTION,
  },
  [PaymentsErrorCodes.INITIATOR_REQUEST_ERROR]: {
    name: 'Initiator request error',
    type: AlertTypes.ERROR,
    title: translations.INITIATOR_REQUEST_ERROR_TITLE,
    description: translations.INITIATOR_REQUEST_ERROR_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_REQUEST_FORBIDDDEN]: {
    name: 'Payment request forbidden',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_FORBIDDDEN_TITLE,
    description: translations.PAYMENT_REQUEST_FORBIDDDEN_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_INITIATOR_FORBIDDDEN]: {
    name: 'Payment initator forbidden',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_FORBIDDDEN_TITLE,
    description: translations.PAYMENT_INITIATOR_FORBIDDDEN_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_APPROVER_FORBIDDDEN]: {
    name: 'Payment approver forbidden',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_FORBIDDDEN_TITLE,
    description: translations.PAYMENT_APPROVER_FORBIDDDEN_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_READER_FORBIDDDEN]: {
    name: 'Payment reader forbidden',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_FORBIDDDEN_TITLE,
    description: translations.PAYMENT_READER_FORBIDDDEN_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_REQUEST_ALREADY_PROCCESSED]: {
    name: 'Payment approver forbidden',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_REQUEST_ALREADY_PROCCESSED_TITLE,
    description: translations.PAYMENT_REQUEST_ALREADY_PROCCESSED_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_OWN_REQUEST_ERROR]: {
    name: 'Payment approver forbidden',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_OWN_REQUEST_ERROR_TITLE,
    description: translations.PAYMENT_OWN_REQUEST_ERROR_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_INVALID_ROLE_ERROR]: {
    name: 'Payment invalid role',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_INVALID_ROLE_ERROR_TITLE,
    description: translations.PAYMENT_INVALID_ROLE_ERROR_DESCRIPTION,
  },
  [PaymentsErrorCodes.ALL_PAYMENT_REQUESTS_FAILED]: {
    name: 'All payment requests failed',
    type: AlertTypes.ERROR,
    title: translations.ALL_PAYMENT_REQUESTS_FAILED_TITLE,
    description: translations.ALL_PAYMENT_REQUESTS_FAILED_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_RECORD_NOT_FOUND]: {
    name: 'Record not found',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_RECORD_NOT_FOUND_TITLE,
    description: translations.PAYMENT_RECORD_NOT_FOUND_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_SUMMARY_NOT_FOUND]: {
    name: 'Summary counters failed',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_SUMMARY_NOT_FOUND_TITLE,
    description: translations.PAYMENT_SUMMARY_NOT_FOUND_DESCRIPTION,
  },
  [PaymentsErrorCodes.INSUFFICIENT_BALANCE]: {
    name: 'Insufficient balance',
    type: AlertTypes.ERROR,
    title: translations.INSUFFICIENT_BALANCE_TITLE,
    description: translations.INSUFFICIENT_BALANCE_DESCRIPTION,
  },
  [PaymentsErrorCodes.TARGET2_BIC_AND_ADDRESS_REQUIRED]: {
    name: 'BIC and Address are required for Target2 payments',
    type: AlertTypes.ERROR,
    title: translations.TARGET2_BIC_AND_ADDRESS_REQUIRED_TITLE,
    description: translations.TARGET2_BIC_AND_ADDRESS_REQUIRED_DESCRIPTION,
  },
  [PaymentsErrorCodes.EXCEEDED_TRANSFER_LIMIT]: {
    name: 'Exceeded Transfer Limit',
    type: AlertTypes.ERROR,
    title: translations.EXCEEDED_TRANSFER_LIMIT_TITLE,
    description: translations.EXCEEDED_TRANSFER_LIMIT_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_REQUEST_FAILED]: {
    name: 'Payment Request Failed',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_REQUEST_FAILED_TITLE,
    description: translations.PAYMENT_REQUEST_FAILED_DESCRIPTION,
  },
  [PaymentsErrorCodes.INVALID_AMOUNT]: {
    name: 'Invalid Amount',
    type: AlertTypes.ERROR,
    title: translations.INVALID_AMOUNT_TITLE,
    description: translations.INVALID_AMOUNT_DESCRIPTION,
  },
  [PaymentsErrorCodes.AMOUNT_TOO_LOW]: {
    name: 'Amount too low',
    type: AlertTypes.ERROR,
    title: translations.AMOUNT_TOO_LOW_TITLE,
    description: translations.AMOUNT_TOO_LOW_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_FAILED_BIC_REQUIRED]: {
    name: 'Payment Failed',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_FAILED_BIC_REQUIRED_TITLE,
    description: translations.PAYMENT_FAILED_BIC_REQUIRED_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENT_FAILED_ADDRESS_REQUIRED]: {
    name: 'Payment Failed',
    type: AlertTypes.ERROR,
    title: translations.PAYMENT_FAILED_ADDRESS_REQUIRED_TITLE,
    description: translations.PAYMENT_FAILED_ADDRESS_REQUIRED_DESCRIPTION,
  },
  [PaymentsSuccessCodes.WITHDRAW_SUCCESS]: {
    name: 'Withdrawal Success',
    type: AlertTypes.SUCCESS,
    title: translations.WITHDRAW_SUCCESS_TITLE,
    description: translations.WITHDRAW_SUCCESS_DESCRIPTION,
  },
  [PaymentsErrorCodes.CUSTOMER_IS_NOT_ENROLLED]: {
    name: 'Customer is not enrolled',
    type: AlertTypes.ERROR,
    title: translations.CUSTOMER_IS_NOT_ENROLLED_TITLE,
    description: translations.CUSTOMER_IS_NOT_ENROLLED_DESCRIPTION,
  },
  [PaymentsErrorCodes.SCHEDULED_PAYMENT_CANCELLED_FAILED]: {
    name: 'Scheduled Payment Cancel Failed',
    type: AlertTypes.ERROR,
    title: translations.SCHEDULED_PAYMENT_CANCELLED_FAILED_TITLE,
    description: translations.SCHEDULED_PAYMENT_CANCELLED_FAILED_DESCRIPTION,
  },
  [PaymentsErrorCodes.PAYMENTS_CANCELLED_FAILED]: {
    name: 'Payment Cancel Failed',
    type: AlertTypes.ERROR,
    title: translations.PAYMENTS_CANCELLED_FAILED_TITLE,
    description: translations.PAYMENTS_CANCELLED_FAILED_DESCRIPTION,
  },
  [PaymentsErrorCodes.EQUALS_EXCHANGE_NEXT_TRADING_DAY_REQUIRED]: {
    name: 'Exchange next trading day required',
    type: AlertTypes.ERROR,
    title: translations.EQUALS_EXCHANGE_NEXT_TRADING_DAY_REQUIRED_TITLE,
    description: translations.EQUALS_EXCHANGE_NEXT_TRADING_DAY_REQUIRED_DESCRIPTION,
  },
  [PaymentsErrorCodes.EQUALS_PAYMENT_EXCHANGE_TARGET_CURRENCY_UNRESOLVED]: {
    name: 'Target currency unavailable',
    type: AlertTypes.ERROR,
    title: translations.EQUALS_PAYMENT_EXCHANGE_TARGET_CURRENCY_UNRESOLVED_TITLE,
    description: translations.EQUALS_PAYMENT_EXCHANGE_TARGET_CURRENCY_UNRESOLVED_DESCRIPTION,
  },
  [PaymentsErrorCodes.EQUALS_PAYMENT_EXCHANGE_UNSUPPORTED_FROM_SUB_BUDGET]: {
    name: 'Payment exchange not supported from this budget',
    type: AlertTypes.ERROR,
    title: translations.EQUALS_PAYMENT_EXCHANGE_UNSUPPORTED_FROM_SUB_BUDGET_TITLE,
    description: translations.EQUALS_PAYMENT_EXCHANGE_UNSUPPORTED_FROM_SUB_BUDGET_DESCRIPTION,
  },
  [PaymentsSuccessCodes.SCHEDULED_PAYMENT_CANCELLED]: {
    name: 'Scheduled Payment Cancelled',
    type: AlertTypes.SUCCESS,
    title: translations.SCHEDULED_PAYMENT_CANCELLED_TITLE,
    description: translations.SCHEDULED_PAYMENT_CANCELLED_DESCRIPTION,
  },
  [PaymentsSuccessCodes.PAYMENTS_CANCELLED]: {
    name: 'Payment Cancelled',
    type: AlertTypes.SUCCESS,
    title: translations.PAYMENTS_CANCELLED_TITLE,
    description: translations.PAYMENTS_CANCELLED_DESCRIPTION,
  },
  [PaymentsSuccessCodes.SUBMIT_WITHDRAWAL_NOTICE]: {
    name: 'Notice submitted',
    type: AlertTypes.SUCCESS,
    title: translations.SUBMIT_WITHDRAWAL_NOTICE_TITLE,
    description: translations.SUBMIT_WITHDRAWAL_NOTICE_DESCRIPTION,
  },
  [PaymentsErrorCodes.FAIL_WITHDRAWAL_NOTICE]: {
    name: 'Notice could not be submitted',
    type: AlertTypes.ERROR,
    title: translations.FAIL_WITHDRAWAL_NOTICE_TITLE,
    description: translations.FAIL_WITHDRAWAL_NOTICE_DESCRIPTION,
  },
  [PaymentsErrorCodes.DESCRIPTION_LIMIT_VALIDATION_ERROR]: {
    name: 'Description/Reference too long',
    type: AlertTypes.ERROR,
    title: translations.DESCRIPTION_LIMIT_VALIDATION_ERROR_TITLE,
    description: translations.DESCRIPTION_LIMIT_VALIDATION_ERROR_DESCRIPTION,
  },
});
